export function getObjectProp(obj, prop) {
  if (!obj) {
    return obj;
  }
  const property = prop.split('.');
  let value = obj;

  for (let i = 0; i < property.length; i++) {
    if (value) {
      value = value[property[i]];
    } else {
      value = undefined;
      break;
    }
  }
  return value !== undefined ? value : obj[prop];
}

export function sortItemsByPropertyName(property, ascending = true) {
  return (aItem, bItem) => {
    const aValue = getObjectProp(aItem, property);
    const bValue = getObjectProp(bItem, property);
    if (aValue !== undefined && bValue !== undefined) {
      const a = typeof aValue === 'string' ? aValue.toUpperCase() : aValue;
      const b = typeof bValue === 'string' ? bValue.toUpperCase() : bValue;
      if (a < b || (a === null && b !== null)) {
        return ascending ? -1 : 1;
      }
      if (a > b || (a !== null && b === null)) {
        return ascending ? 1 : -1;
      }
    }
    return 0;
  };
}
